import React from "react";
import HelpBackButton from "./HelpBackButton";

const HelpCenterLayout = ({
  children,
  className = "",
  showBackButton = true,
  backFallbackTo = "/",
}) => {
  return (
    <div className={`help-center-shell ${className}`.trim()}>
      <div className="help-center-shell-inner">
        {showBackButton ? <HelpBackButton fallbackTo={backFallbackTo} /> : null}
        {children}
      </div>
    </div>
  );
};

export default HelpCenterLayout;
